import { getCardType, userAccountInfo } from 'helpers/user'
import images from 'const/images'
import { clientInfo, features } from 'configureBrand'
import i18n from 'lang/i18n'
import { ReactElement } from 'react'
import { UserAccountType } from 'typings/userInfo'

const { proxCard, brcCard, dcCard } = images

export const getCardImage = (clientName: ClientKeys): string => {
  const { isProx, cardType } = userAccountInfo
  if (clientName === 'sams' && !isProx) {
    return cardType?.toLowerCase() === 'plcc' ? brcCard : dcCard
  }
  return isProx ? proxCard : brcCard
}

/**
 * Checks to see if prox account is supported. Returns false if prox is allowed.
 * Return true if the account type is prox and prox is not enabled.
 */
export const hasAccountNotSupported = (accountType: string) => {
  if (features.allowProx) {
    return false
  }
  return accountType === 'prox'
}

export const getInlineBusinessHours = (
  clientName: ClientKeys
): string | ReactElement => {
  switch (clientName) {
    case 'sams':
      return i18n({ clientInfo: 'samsBusinessHoursInline' }, {})
    case 'flooranddecor':
      return i18n({ clientInfo: 'floorAndDecorBusinessHoursInline' }, {})
    case 'lowes':
    default:
      return i18n({ clientInfo: 'lowesBusinessHoursInline' }) as string
  }
}

export const shouldShowRegistrationRequirement = (
  clientName: ClientKeys
): boolean => {
  return clientName === 'sams'
}

export const shouldShowFooterCardInfo = (clientName: ClientKeys): boolean => {
  return clientName === 'sams'
}

export const isDualCard = (): boolean => {
  return getCardType() === 'dualcard'
}

export const shouldShowQuestion = (clientName: ClientKeys): boolean => {
  return ['sams'].includes(clientName)
}

/**
 * Returns the video list path for the given account type from brand
 * configuration.
 */
export const getVideoListPath = (accountType: UserAccountType) =>
  accountType === 'brc'
    ? clientInfo.video.brcVideoListPath
    : clientInfo.video.proxVideoListPath
